import { useQuery } from '@tanstack/react-query'
import { api, type MeResponse } from '../../api/client'

/** Whether the signed-in operator may see named member history (the server's effective value). */
export function useMemberAccess(): { canMember: boolean; loaded: boolean } {
  const { data: me } = useQuery<MeResponse>({ queryKey: ['me'], queryFn: () => api.get<MeResponse>('/api/me'), staleTime: 60_000, retry: false })
  return { canMember: me?.can_view_member_activity === true, loaded: me !== undefined }
}

export const COLLECTING_TEXT = 'Collecting — the score appears after two weeks of reading data'

export const btn = (on: boolean) =>
  `min-h-[32px] px-3 font-mono text-[12px] border ${
    on ? 'border-amber-glow text-amber-glow bg-ink-700' : 'border-ink-500 text-paper-dim hover:text-paper hover:bg-ink-700'
  }`
